

















import { IProduct } from '@/common/interfaces/products.interface';
import Vue from 'vue';
import OldFormatHelper from '../../helpers/OldFormatHelper';

export default Vue.extend({
  name: `ProductListPriceDisplay`,
  props: {
    discountActive: {
      required: true,
      type: Boolean,
    },
    isPartner: {
      required: true,
      type: Boolean,
    },
    mode: {
      required: true,
      type: String,
    },
    product: {
      required: true,
      type: Object as () => IProduct,
    },
  },
  methods: {
    getMyOriginalPrice(): string {
      if(!this.product || !this.product.prices || !this.product.prices.customer || !this.product.prices.customer.bruttoWithoutDiscount) {
        return ``;
      }

      const price = this.isPartner ? this.product.prices.partner.bruttoWithoutDiscount : this.product.prices.customer.bruttoWithoutDiscount;

      return OldFormatHelper.getPrice(price);
    },
    getMyPrice(): string {
      if(!this.product || !this.product.prices || !this.product.prices.customer || !this.product.prices.customer.brutto) {
        return ``;
      }

      const price = this.isPartner ? this.product.prices.partner.brutto : this.product.prices.customer.brutto;

      return OldFormatHelper.getPrice(price);
    },
  },
});
